var unauthenticatedCtrlID = 'unauthenticatedCtrl';
var cookieName = 'browserVersionCheck';

if (typeof globalThis === 'undefined') {
  if (typeof window !== 'undefined') {
    window.globalThis = window;
  } else if (typeof global !== 'undefined') {
    global.globalThis = global;
  } else if (typeof self !== 'undefined') {
    self.globalThis = self;
  }
}

function detectBrowserAndVersionNumber() {
    var userAgent= navigator.userAgent;
    var temp; 
    var browserDetails= userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(browserDetails[1])){
        temp=  /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return 'IE '+(tem[1] || '');
    }
    if(browserDetails[1]=== 'Chrome'){
        temp = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
        if(temp != null) return temp.slice(1).join(' ').replace('OPR', 'Opera');
    }
    browserDetails = browserDetails[2] ? [browserDetails[1], browserDetails[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((temp = userAgent.match(/version\/(\d+)/i))!= null) browserDetails.splice(1, 1, temp[1]);
    
    return browserDetails;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }

  var secureFlag = '';
  if (window.location.protocol === 'https:') {
    secureFlag = '; Secure';
  }
  document.cookie = name + "=" + (value || "")  + expires + '; SameSite=None' + secureFlag + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var cookieList = document.cookie.split(';');
  for(var i = 0; i < cookieList.length; i++) {
      var cookie = cookieList[i];
      while (cookie.charAt(0)==' ') cookie = cookie.substring(1, cookie.length);
      if (cookie.indexOf(nameEQ) == 0) return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
}

function renderAlertIcon(node) {
  var iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  iconSvg.setAttribute('fill', 'none');
  iconSvg.setAttribute('viewBox', '0 0 26 26');
  iconSvg.setAttribute('data-cache', '21600');
  iconSvg.setAttribute('height', '25');
  iconSvg.setAttribute('width', '25');
  iconSvg.classList.add('alert-svg');
  iconSvg.style.float = 'left';
  iconSvg.style.marginRight = '15px';
  
  var g = document.createElementNS("http://www.w3.org/2000/svg", "g");
  iconSvg.appendChild(g);

  // svg for alert circle:
  var circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  circle.setAttribute('cx', '13');
  circle.setAttribute('cy', '13');
  circle.setAttribute('r',  '12');
  circle.setAttribute('stroke', '#E81132');
  circle.setAttribute('stroke-width', '2');
  g.appendChild(circle);

  // svg exclamationMark: 
  var iconPath1 = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'path'
  );
  iconPath1.setAttribute(
    'd',
    'M11.3344 6.4H14.6824L14.1244 14.626H11.8924L11.3344 6.4ZM13.0084 19.144C12.5164 19.144 12.1024 18.988 11.7664 18.676C11.4424 18.352 11.2804 17.962 11.2804 17.506C11.2804 17.05 11.4424 16.672 11.7664 16.372C12.0904 16.06 12.5044 15.904 13.0084 15.904C13.5124 15.904 13.9264 16.06 14.2504 16.372C14.5744 16.672 14.7364 17.05 14.7364 17.506C14.7364 17.962 14.5684 18.352 14.2324 18.676C13.9084 18.988 13.5004 19.144 13.0084 19.144Z'
  );
  iconPath1.setAttribute('fill', '#E81132');
  iconSvg.appendChild(iconPath1);

  //wrap it in a span
  var container = document.createElement('span');
  container.appendChild(iconSvg);
  
  return node.appendChild(container);
}


function waitForElementToDisplay(selector, alertElement, checkFrequencyInMs, timeoutInMs) {
  var startTimeInMs = Date.now();
  (function loopSearch() {
    if (document.getElementById(selector)) {
      addAnalytics(true);
      alertElement.style.position = 'relative';
      insertAfter(document.getElementById(unauthenticatedCtrlID).firstChild, alertElement);  //if page loads normally
      return;
    }
    else {
      setTimeout(function() {
        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
          addAnalytics(false);

          //modify css to add alert at the top of the page
          if (document.getElementById('op-global-header')) {
              document.getElementById('op-global-header').setAttribute('style', 'position:relative !important');
              document.querySelector('main').style.marginTop = '0';
          }
          document.body.insertBefore(alertElement, document.body.firstChild);
          return;
        }
        loopSearch();
      }, checkFrequencyInMs);
    }
  })();
}


function displayAlertMessage(titleText, errorText) {
    var alertElement = document.createElement("div");
    alertElement.setAttribute("id", "browserOutOfDateAlert");
    alertElement.style.background = "#fef3f3";
    alertElement.style.border = "1px solid #FA0037";
    alertElement.style.padding = "15px";
    alertElement.style.color = "#240B14";
    alertElement.style.position = 'fixed'; //changes if header loads
    alertElement.style.top = '0';
    alertElement.style.left = '0'
    alertElement.style.zIndex = "1";
    alertElement.style.width = "100%"

    var div = document.createElement('div');

    var messageElement = document.createElement("strong");
    // messageElement.className = "error-text";
    messageElement.innerText = titleText;
    
    var errorTextElement = document.createElement("p");
    errorTextElement.style.fontSize = "18px";
    errorTextElement.style.color = "#240B14";
    errorTextElement.style.marginLeft = "40px";
    errorTextElement.style.width = "auto";
    errorTextElement.innerText = errorText;

    renderAlertIcon(alertElement); 
    alertElement.appendChild(messageElement);
    alertElement.appendChild(errorTextElement);
    waitForElementToDisplay(unauthenticatedCtrlID, alertElement, 500, 5000);
}

function remove() {
  document.getElementById('browserOutOfDateAlert').remove();
}

function addAnalytics(idPresent) {
  if (window.aa == undefined) {
    window.aa = {};
  }
  aa.errorMessage = "outdated browser";
  aa.errorType = browser + " " + version;
  if (!idPresent) {
    aa.errorCode = unauthenticatedCtrlID + " ID not loaded";
  }
  else {
    aa.errorCode = "outdated browser";
  }

  var applicationReadyToBeTrackedEvent = new CustomEvent(
    'application-ready-to-be-tracked', {
      detail: window.aa
    });
  document.dispatchEvent(applicationReadyToBeTrackedEvent);
}


function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

var browerAndVersion = detectBrowserAndVersionNumber();
var browser = browerAndVersion[0];
var version = browerAndVersion[1];

var compatabilityMap = {
  'Chrome':  79,
  'Firefox': 84,
  'Safari': 14,
  'Edge': 79,
  'msie': 10
}

if (!getCookie(cookieName) && version <= compatabilityMap[browser]) {
    setCookie(cookieName, 'ranOnceAlready', 0.5);
  
    var heading = "Your browser isn't supported";
    var text = "Outdated browsers can expose your computer to security risks. To get the best experience using our website, you’ll need to upgrade to a newer browser.";
    
    if (getCookie('language') == 'fr') {
        heading = "Navigateur non pris en charge";
        text = "Les versions périmées de navigateurs peuvent exposer votre ordinateur à des risques de sécurité. Pour bénéficier de la meilleure expérience lorsque vous utilisez notre site Web, vous devrez mettre votre navigateur à jour.";
        displayAlertMessage(heading, text); 
    }
    else {
        displayAlertMessage(heading, text);
    }
}
